package com.milta.core.localization.translations.en

import com.milta.core.localization.TeamStrings

internal val Team = TeamStrings(
    screenTitle = "Team",
    statusActive = "Active",
    errorGeneric = "An error occurred. Please try again.",
    monthNames = listOf("January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"),
    enterpriseSectionLabel = "Team drivers",
    enterpriseEmptyHint = "No drivers in your team yet.",
    noEnterpriseFound = "No enterprise linked to your account.",
    columnHeaderDriver = "Driver",
    columnHeaderStatus = "Status",
    columnHeaderActions = "Actions",
    addDriverSectionTitle = "Add a driver",
    addDriverCodePlaceholder = "Milta code — e.g. MTA-28371",
    addDriverButton = "Add this driver",
    addDriverErrorInvalidCode = "Please enter a valid code.",
    addDriverErrorNotFound = "Invalid or already used code.",
    addDriverErrorAlreadyMember = "This driver is already part of your team.",
    addDriverErrorLinkedAccountIsEnterprise = "This account is an enterprise and cannot be added as a driver.",
    addDriverErrorLimitReached = "Limit reached: an Enterprise cannot have more than 10 members, including you. Remove a driver to add another one.",
    addDriverErrorEnterpriseSubscriptionInactive = "Your Enterprise subscription has expired: renew it to add a driver.",
    driverDetailTitle = "Driver details",
    driverDetailPhoneLabel = "Phone",
    removeDriverButton = "Remove",
    removeDriverDialogTitle = "Remove this driver?",
    removeDriverDialogMessagePrefix = "You are about to remove",
    removeDriverDialogMessageSuffix = "from your team. Their Milta account will stay active.",
    removeDriverErrorNotFound = "Driver not found.",
    removeDriverErrorOnActiveDelivery = "This driver is currently on an active delivery and cannot be removed.",
    removeDriverErrorLastOwner = "You are the only manager of this enterprise. Add another Enterprise account before removing yourself from the team.",
)
